import type { BoxProps, StackProps, TypographyProps } from "@mui/material";
import { Box, Stack, Typography, styled } from "@mui/material";

export const PageContainer: React.ComponentType<BoxProps> = styled(Box)(
  ({ theme }) => ({
    width: "100%",
    minWidth: 0,
    paddingBottom: theme.spacing(10), // desktop
    [theme.breakpoints.down("md")]: {
      paddingBottom: theme.spacing(4), // mobile
    },
  }),
);

export const ContentStack: React.ComponentType<StackProps> = styled(Stack)(
  ({ theme }) => ({
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    [theme.breakpoints.up("md")]: {
      maxWidth: "640px",
    },
  }),
);

export const PageTitle: React.ComponentType<TypographyProps> = styled(
  Typography,
)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 18,
  lineHeight: "24px",
  letterSpacing: "0.02em",
  color: theme.colors.text[5],
  [theme.breakpoints.up("md")]: {
    fontSize: 28,
    lineHeight: "36px",
  },
}));
